<template>
  <div>
    <el-dialog
      title="编辑教务老师"
      :visible="visible"
      append-to-body
      destroy-on-close
      @close="handleCloseDialog"
      width="656px"
    >
      <div>
        <el-form
          ref="form"
          :model="searchForm"
          label-width="105px"
          inline
          @submit.native.prevent
          size="mini"
        >
          <el-form-item label="教务老师搜索:">
            <el-input
              v-model="searchForm.key_word"
              @change="searchChange"
              prefix-icon="el-icon-search"
              placeholder="请输入教务老师姓名或手机号"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
        <el-table
          size="mini"
          :data="tableData"
          v-horizontal-scroll
          style="width: 100%"
          tooltip-effect="dark"
          stripe
          class="mwow-table micro"
          @row-click="handleRowClick"
          @cell-mouse-enter="handleCellMouse"
          ref="tableRef"
        >
          <el-table-column label="员工姓名" prop="name">
            <template slot-scope="scope">
              <span class="column-name active">
                {{ scope.row.name }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="手机号" prop="name">
            <template slot-scope="scope">
              <div class="active">
                {{ "+" + scope.row.area_code }} {{ scope.row.mobile }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="page"
          :page-size="pageSize"
          :page-sizes="pageSizeArray"
          :pager-count="5"
          :style="{
            display: 'flex',
            justifyContent: 'flex-end',
            padding: '20px',
          }"
          :total="total"
          @current-change="handlePagerChange"
          @size-change="handlePagerSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { staffList } from "@/api/globalSearch";
import { editEduTeacherApi } from "@/api/rollCallRecord";

export default {
  props: ["originId", "visible"],
  data() {
    return {
      searchForm: {
        key_word: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
    };
  },
  watch: {
    visible: {
      handler(n) {
        if (n) {
          setTimeout(() => {
            this.getList({
              page: 1,
              page_size: 10,
            });
          }, 100);
        }
      },
    },
  },
  methods: {
    handleRowClick(...rest) {
      editEduTeacherApi({
        edu_teacher_id: Number(rest[0].staff_id),
        roll_call_student_ids: [Number(this.originId)],
      }).then((res) => {
        if (res.error_code === 0) {
          this.$message({
            message: "变更成功",
            type: "success",
          });
          this.handleCloseDialog(true);
        }
      });
    },
    getList(value) {
      const option = {
        page: value.page,
        page_size: value.page_size,
        status: 1,
        job_ids: [2],
      };
      if (this.searchForm.key_word) {
        option.key_word = this.searchForm.key_word;
      }
      staffList(option).then((res) => {
        if (res.error_code === 0) {
          this.tableData = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    handleCloseDialog(val) {
      // 只有当 val 为 true 时，通知父组件重新获取数据
      this.$emit("change", val);
    },
    handleCellMouse(...rest) {
      console.log(rest, rest[2]);
    },
    searchChange() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
  },
};
</script>
<style scoped lang="scss">
/deep/ .el-form-item__content {
  width: 230px !important;
}
.column-name {
  border: 1px solid rgba(231, 232, 234, 1);
  border-radius: 4px;
  display: inline-block;
  padding: 0 10px;
  margin: 3px 0;
}
::v-deep tr:hover {
  td {
    cursor: pointer;
    .cell {
      .active {
        color: #07d1aa;
      }
      .column-name {
        border: 1px solid #07d1aa;
      }
    }
  }
}
</style>
